var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"legacy-layout",class:{'legacy-layout--mobile': _vm.isMobile}},[_c('div',{staticClass:"legacy-layout__header"},[_vm._t("header")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }